/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FetchData } from "app/shared/generalMethods";
import { environment } from "environments/environment";
import { catchError, Observable } from "rxjs";

@Injectable()
export class AdminProgramService {
  headers: HttpHeaders;
  options: any;
  user: any;
  serverUrl = environment.apiUrl;
  serverCache = environment.apiUrlCache;

  constructor(
    private http: HttpClient,
    private _httpClient: HttpClient,
    private _fetchData: FetchData
  ) {}

  getAdminByUID(id): Observable<any> {
    const url = this.serverUrl + "/adminByUID?id=" + id;
    return this._httpClient.get(url, this.options);
  }

  addAdministrator(payload: any, uid: string): Observable<any> {
    const url = this.serverUrl + "/addAdministrator";

    // Ensure payload has correct field names including the UID
    const requestBody = {
      uid: uid, // Use the uid parameter passed to the method
      name: payload.Administrator_Name__c,
      email: payload.Email__c,
      address: payload.Address__c,
      city: payload.Town_City__c,
      isActive: payload.Is_Active__c,
      role: payload.Role__c,
      cellPhone: payload.Phone__c,
      organizationId: payload.Organization__c,
    };

    return this.http.post(url, requestBody).pipe(
      catchError((error) => {
        console.error("API Error:", error);
        throw new Error(error.error?.error || "Failed to add administrator");
      })
    );
  }

  updateAdministrator(record: any, uid: string, id: string): Observable<any> {
    const url = this.serverUrl + "/updateAdministrator";
    const body = {
      adminIdOrUid: uid,
      Id: id,
      name: record.Administrator_Name__c,
      address: record.Address__c,
      city: record.Town_City__c,
      cellPhone: record.Phone__c,
    };
    return this._httpClient.put(url, body, this.options);
  }
  updateOrganization(orgData: any, adminId: string): Observable<any> {
    const url = `${this.serverUrl}/updateOrganization?adminId=${adminId}`;
    const body = {
      adminIdOrUid: adminId,
      Id: orgData.Id,
      Organization_Name__c: orgData.Organization_Name__c,
      Phone_Number__c: orgData.Phone_Number__c,
      Organization_Address__c: orgData.Organization_Address__c,
      Organization_Image__c: orgData.Organization_Image__c,
    };

    return this._httpClient.put(url, body, this.options).pipe(
      catchError((error) => {
        console.error("Error updating organization:", error);
        throw new Error("Failed to update organization");
      })
    );
  }
  createProgram(programData: any, adminId: string): Observable<any> {
    // const url = this.serverUrl + '/createProgram';
    const url = this.serverUrl + "/createProgram?adminId=" + adminId;
    const body = {
      adminIdOrUid: adminId,
      Name: programData.Name,
      Program_Description__c: programData.Program_Description__c,
      Category_of_Program__c: programData.Category_of_Program__c,
      Age_Group__c: programData.Age_Group__c,
      Is_Active__c: programData.Is_Active__c,
      All_Day_Program__c: programData.All_Day_Program__c,
      Program_Location__c: programData.Program_Location__c,
      Location__c: programData.Location__c,
      Instructor__c: programData.Instructor__c,
      Start_Date__c: programData.Start_Date__c,
      End_Date__c: programData.End_Date__c,
      Monday__c: programData.Monday__c,
      Tuesday__c: programData.Tuesday__c,
      Wednesday__c: programData.Wednesday__c,
      Thursday__c: programData.Thursday__c,
      Friday__c: programData.Friday__c,
      Saturday__c: programData.Saturday__c,
      Sunday__c: programData.Sunday__c,
      Start_Time_Monday__c: programData.Start_Time_Monday__c,
      End_Time_Monday__c: programData.End_Time_Monday__c,
      Start_Time_Tuesday__c: programData.Start_Time_Tuesday__c,
      End_Time_Tuesday__c: programData.End_Time_Tuesday__c,
      Start_Time_Wednesday__c: programData.Start_Time_Wednesday__c,
      End_Time_Wednesday__c: programData.End_Time_Wednesday__c,
      Start_Time_Thursday__c: programData.Start_Time_Thursday__c,
      End_Time_Thursday__c: programData.End_Time_Thursday__c,
      Start_Time_Friday__c: programData.Start_Time_Friday__c,
      End_Time_Friday__c: programData.End_Time_Friday__c,
      Start_Time_Saturday__c: programData.Start_Time_Saturday__c,
      End_Time_Saturday__c: programData.End_Time_Saturday__c,
      Start_Time_Sunday__c: programData.Start_Time_Sunday__c,
      End_Time_Sunday__c: programData.End_Time_Sunday__c,
      Available_Space__c: programData.Available_Space__c,
      Available_Waiting_Space__c: programData.Available_Waiting_Space__c,
      Program_Fee__c: programData.Program_Fee__c,
      Subsidized_Amount__c: programData.Subsidized_Amount__c,
      Cancellation_Policy__c: programData.Cancellation_Policy__c,
      Payment_Term__c: programData.Payment_Term__c,
      Payment_Disclaimer__c: programData.Payment_Disclaimer__c,
      Gain_Description__c: programData.Gain_Description__c,
      Notes__c: programData.Notes__c,
      Less_than_days__c: programData.Less_than_days__c,
      In_between_days__c: programData.In_between_days__c,
      Greater_than_days__c: programData.Greater_than_days__c,
      Percentage_Less__c: programData.Percentage_Less__c,
      Percentage_Between__c: programData.Percentage_Between__c,
      Percentage_Greater__c: programData.Percentage_Greater__c,
      Message_Less_than_days__c: programData.Message_Less_than_days__c,
      Message_In_between_days__c: programData.Message_In_between_days__c,
      Message_Greater_than_days__c: programData.Message_Greater_than_days__c,
      Community_Image__c: programData.Community_Image__c,
      Organization_Address__c: programData.Organization_Address__c,
      Organization_Number__c: programData.Organization_Number__c,
      Organization_Name__c: programData.Organization_Name__c,
      Organization__c: programData.Organization__c,
      Apply_Fees_By_Program__c: programData.Apply_Fees_By_Program__c,
      Apply_Fees_By_Class_Schedule__c:
        programData.Apply_Fees_By_Class_Schedule__c,
      Key_Outcome__c: programData.Key_Outcome__c,
      Program_Image__c: programData.Program_Image__c,
      Curriculum_Outline__c: programData.Curriculum_Outline__c,
      isActive: true,
      ignoreValidation: false,
    };
    return this._httpClient.post(url, body, this.options);
  }

  updateProgram(programData: any, adminId: string): Observable<any> {
    const url = this.serverUrl + "/updateProgram?adminId=" + adminId;
    const body = {
      adminIdOrUid: adminId,
      Id: programData.Id,
      Name: programData.Name,
      Program_Description__c: programData.Program_Description__c,
      Category_of_Program__c: programData.Category_of_Program__c,
      Age_Group__c: programData.Age_Group__c,
      Is_Active__c: programData.Is_Active__c,
      All_Day_Program__c: programData.All_Day_Program__c,
      Program_Location__c: programData.Program_Location__c,
      Location__c: programData.Location__c,
      Instructor__c: programData.Instructor__c,
      Start_Date__c: programData.Start_Date__c,
      End_Date__c: programData.End_Date__c,
      Monday__c: programData.Monday__c,
      Tuesday__c: programData.Tuesday__c,
      Wednesday__c: programData.Wednesday__c,
      Thursday__c: programData.Thursday__c,
      Friday__c: programData.Friday__c,
      Saturday__c: programData.Saturday__c,
      Sunday__c: programData.Sunday__c,
      Start_Time_Monday__c: programData.Start_Time_Monday__c,
      End_Time_Monday__c: programData.End_Time_Monday__c,
      Start_Time_Tuesday__c: programData.Start_Time_Tuesday__c,
      End_Time_Tuesday__c: programData.End_Time_Tuesday__c,
      Start_Time_Wednesday__c: programData.Start_Time_Wednesday__c,
      End_Time_Wednesday__c: programData.End_Time_Wednesday__c,
      Start_Time_Thursday__c: programData.Start_Time_Thursday__c,
      End_Time_Thursday__c: programData.End_Time_Thursday__c,
      Start_Time_Friday__c: programData.Start_Time_Friday__c,
      End_Time_Friday__c: programData.End_Time_Friday__c,
      Start_Time_Saturday__c: programData.Start_Time_Saturday__c,
      End_Time_Saturday__c: programData.End_Time_Saturday__c,
      Start_Time_Sunday__c: programData.Start_Time_Sunday__c,
      End_Time_Sunday__c: programData.End_Time_Sunday__c,
      Available_Space__c: programData.Available_Space__c,
      Available_Waiting_Space__c: programData.Available_Waiting_Space__c,
      Program_Fee__c: programData.Program_Fee__c,
      Subsidized_Amount__c: programData.Subsidized_Amount__c,
      Cancellation_Policy__c: programData.Cancellation_Policy__c,
      Payment_Term__c: programData.Payment_Term__c,
      Payment_Disclaimer__c: programData.Payment_Disclaimer__c,
      Gain_Description__c: programData.Gain_Description__c,
      Notes__c: programData.Notes__c,
      Less_than_days__c: programData.Less_than_days__c,
      In_between_days__c: programData.In_between_days__c,
      Greater_than_days__c: programData.Greater_than_days__c,
      Percentage_Less__c: programData.Percentage_Less__c,
      Percentage_Between__c: programData.Percentage_Between__c,
      Percentage_Greater__c: programData.Percentage_Greater__c,
      Message_Less_than_days__c: programData.Message_Less_than_days__c,
      Message_In_between_days__c: programData.Message_In_between_days__c,
      Message_Greater_than_days__c: programData.Message_Greater_than_days__c,
      Community_Image__c: programData.Community_Image__c,
      Organization_Address__c: programData.Organization_Address__c,
      Organization_Number__c: programData.Organization_Number__c,
      Organization_Name__c: programData.Organization_Name__c,
      Organization__c: programData.Organization__c,
      Key_Outcome__c: programData.Key_Outcome__c,
      Program_Image__c: programData.Program_Image__c,
      Curriculum_Outline__c: programData.Curriculum_Outline__c,
      isActive: programData.Is_Active__c,
      ignoreValidation: false,
    };
    return this._httpClient.put(url, body, this.options).pipe(
      catchError((error) => {
        console.error("Error updating program:", error);
        throw new Error("Failed to update program");
      })
    );
  }
  createCommunity(communityData: any, adminId: string): Observable<any> {
    const url = this.serverUrl + "/createCommunity?adminId=" + adminId;
    const body = {
      adminIdOrUid: adminId,
      Name: communityData.Name,
      Community_Description__c: communityData.Community_Description__c,
      Community_Location__c: communityData.Community_Location__c,
      Community_Phone__c: communityData.Community_Phone__c,
      Created_By__c: communityData.Created_By__c,
      isActive: true,
      ignoreValidation: false,
    };
    return this._httpClient.post(url, body, this.options);
  }
  updateClassSchedule(scheduleData: any, adminId: string): Observable<any> {
    const url = this.serverUrl + "/updateClassSchedule?adminId=" + adminId;
    const body = {
      adminIdOrUid: adminId,
      Id: scheduleData.Id,
      Name: scheduleData.Name,
      Program_Fee__c: scheduleData.Program_Fee__c,
      ignoreValidation: false,
    };
    return this._httpClient.put(url, body, this.options).pipe(
      catchError((error) => {
        console.error("Error updating class schedule:", error);
        throw new Error("Failed to update class schedule");
      })
    );
  }
}
